export default {"src":"/_next/static/media/star.91f53ba6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};